export default "__VITE_ASSET__CMIYI$Se__"